import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import xlooLib from "./xlooLib/xlooLib"

Vue.config.productionTip = false
Vue.use(xlooLib);

new Vue({
  vuetify,
  router,
  store,

  render: h => h(App)
}).$mount('#app')
